import React, { Fragment } from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';

import Label from './Label';
import BetweenLabel from './BetweenLabel';

import { AppState } from '../../../appredux';

import { connect } from 'react-redux';

//PM 2021-04-30
export interface MuiCheckboxProps {
    key: string | number,
    id?: string,
    checked: boolean,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    // onChange: (event: React.ChangeEvent<{
    //     name?: string;
    //     checked: boolean;
    // }>, child: React.ReactNode
    // ) => void,
    formControlStyle?: React.CSSProperties,
    label?: string,
    labelHTML?: JSX.Element,
    betweenLabel?: string,
    labelSecondary?: boolean,
    labelBold?: boolean,
    labelBlock?: boolean,
    labelStyle?: React.CSSProperties,
    labelClasses?: string,
    style?: React.CSSProperties,
    className?: string,
    disabled?: boolean,
    checkboxFirst?: boolean,
    color?: 'primary' | 'secondary' | 'default';
}

class MuiCheckbox extends React.Component<MuiCheckboxProps & WithStyles<typeof styles>> {

    //PM 2021-04-30
    checkbox = () => {
        const classes = this.props.classes;

        return (
            <Checkbox
                key={this.props.key || ""}
                id={this.props.id || ""}
                checked={this.props.checked} onChange={this.props.onChange}
                color={this.props.color || 'primary'}
                style={this.props.style}
                className={`${classes.checkbox} this.props.className`}
                disabled={this.props.disabled}
            />
        )
    }

    //PM 2021-04-30
    render() {
        const classes = this.props.classes;

        return (
            <Fragment>
                <FormControl
                    variant="outlined" margin="normal" fullWidth
                    className={classes.formControl}
                    style={this.props.formControlStyle}
                >
                    {this.props.checkboxFirst ? this.checkbox() : null}
                    {this.props.betweenLabel ?
                        <BetweenLabel
                            label={this.props.betweenLabel}
                            secondary={this.props.labelSecondary}
                        />
                        :
                        <Label
                            key={this.props.key || ""}
                            label={this.props.label}
                            labelHTML={this.props.labelHTML}
                            secondary={this.props.labelSecondary}
                            bold={this.props.labelBold}
                            block={this.props.labelBlock}
                            style={this.props.labelStyle}
                            className={this.props.labelClasses}
                        />
                    }
                    {this.props.checkboxFirst ? null : this.checkbox()}
                </FormControl>
            </Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    formControl: {
        marginTop: "8px",
        display: "block",
        //paddingBottom: "35px"
    },
    checkbox: {
        //padding: '5.5px 0px',
        //color: theme.palette.primary.main,
    }
});

const mapStateToProps = (state: AppState) => ({
    dirtyBackground: state.pageState.secondaryLight
});

export default connect(mapStateToProps)(withStyles(styles)(MuiCheckbox));